import type { IResourceItem } from "@refinedev/core";

/**
 * The featuresv2 keys a resource lists in `meta.requiredPermissions`; empty when unrestricted.
 */
export const getRequiredPermissions = (resource?: IResourceItem): string[] => {
  return (resource?.meta?.requiredPermissions as string[] | undefined) ?? [];
};

/**
 * Any-of check shared by the access-control provider and the header: an unrestricted resource
 * is always allowed, otherwise at least one listed key must be held.
 */
export const hasRequiredPermissions = (
  resource: IResourceItem | undefined,
  hasFeature: (key: string) => boolean
): boolean => {
  const required = getRequiredPermissions(resource);
  return required.length === 0 || required.some(key => hasFeature(key));
};
